import { render, staticRenderFns } from "./ownershipedit.vue?vue&type=template&id=0dad37b9&scoped=true&"
import script from "./ownershipedit.vue?vue&type=script&lang=js&"
export * from "./ownershipedit.vue?vue&type=script&lang=js&"
import style0 from "./ownershipedit.vue?vue&type=style&index=0&id=0dad37b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dad37b9",
  null
  
)

export default component.exports